export interface PasswordRule {
  id: 'length' | 'number' | 'uppercase' | 'lowercase' | 'special';
  label: string;
  test: (password: string) => boolean;
}

/**
 * The same rule set the Identity password policy and the other EPN password screens use (8+ characters, a digit, an
 * uppercase and a lowercase letter, a special character). The server is the source of truth; this is the live hint.
 */
export const PASSWORD_RULES: readonly PasswordRule[] = [
  { id: 'length', label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { id: 'number', label: 'At least one number', test: (p) => /[0-9]/.test(p) },
  { id: 'uppercase', label: 'At least one uppercase letter', test: (p) => /[A-Z]/.test(p) },
  { id: 'lowercase', label: 'At least one lowercase letter', test: (p) => /[a-z]/.test(p) },
  { id: 'special', label: 'At least one special character', test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export function passwordRuleResults(password: string): Array<PasswordRule & { met: boolean }> {
  return PASSWORD_RULES.map((r) => ({ ...r, met: r.test(password) }));
}
